export const getFlashHeight = (flashIndex: number, container?: HTMLDivElement): Promise<number> =>
    new Promise(resolve => {
        const questioners = container!.querySelectorAll('.questioner-container');
        const respondents = container!.querySelectorAll('.respondent-container');
        let scrollTop = 0;
        for (let i = 0; i < questioners.length; i++) {
            if (i >= flashIndex) {
                resolve(scrollTop);
                return;
            }
            // console.log(`questioners-${i}-${questioners[i]?.clientHeight}`);
            // console.log(`respondents-${i}-${respondents[i]?.clientHeight}`);
            scrollTop += (questioners[i]?.clientHeight || 0) + (respondents[i]?.clientHeight || 0) + 48;
        }
        resolve(scrollTop);
    });
